export default __webpack_public_path__ + "static/nodejs-ef2cb7915972765d9a418e3b88c824ae.png";